import { FC } from 'react';
import { UtilityText } from 'components/Typography';

interface Props {
  primaryElectionDate?: string;
}
export const CompetitivePrimaryDetail: FC<Props> = ({ primaryElectionDate }) => {
  return (
    <>
      {primaryElectionDate && (
        <div className="candidate-detail-row">
          <UtilityText>Primary Date:</UtilityText>
          <UtilityText>{primaryElectionDate}</UtilityText>
        </div>
      )}
      <div className="candidate-detail-row wrapped">
        <UtilityText>Primary Details:</UtilityText>
        <UtilityText>
          Candidate is in a competitive primary
          {primaryElectionDate && ` on ${primaryElectionDate}`}. They may or may not be the Democrat
          on the ballot in November.
        </UtilityText>
      </div>
    </>
  );
};
